// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n5-0";
export var animationContainer = "_n5-1";
export var itemPrice = "_n5-a";
export var itemizedContent = "_n5-9";
export var itemizedHeader = "_n5-7";
export var itemizedRow = "_n5-8";
export var itemizedSection = "_n5-6";
export var modalContent = "_n5-2";
export var orderName = "_n5-3";
export var refundOption = "_n5-4";
export var refundOptionsContainer = "_n5-5";
export var shippingLabel = "_n5-b";
export var totalRow = "_n5-c";